/* eslint-disable */

import React from "react";
import Modal from "react-bootstrap/Modal";
import APIClient from "../client";
import { Tab, Tabs } from "react-bootstrap";
import Jobs from "./Jobs";
import cropr from "../../shared/utils/cropr";
import gettext from "../../shared/utils/gettext";
import { interpolate } from "../../shared/utils/legacy";
import Tractors from "./Tractors";

class LinkClaasTelematics extends React.Component {
  state = {
    showModal: false,
    account: null,
    showWarning: false,
  };

  constructor(props, context) {
    super(props, context);
    this.loadAccount();
  }

  componentDidMount() {
    cropr.updateClaasTelematicsState = () => {
      this.loadAccount();
    };
  }
  componentWillUnmount() {
    delete cropr.updateClaasTelematicsState;
  }

  loadAccount = () => {
    fetch("/apps/cloudfarm/get_tractors/C/")
      .then((response) => {
        if (response.status === 401) {
          cropr.notify(
            "danger",
            interpolate(gettext("Your %s authorization seems to be no longer valid."), [
              "CLAAS Telematics",
            ])
          );
        }
        if (response.ok) {
          response.json().then((account) => {
            this.setState({
              account: account,
              showWarning: false,
            });
          });
        } else {
          throw { status: response.status };
        }
      })
      .catch((error) => {
        this.setState({
          account: null,
        });
      });
  };

  authorizeAccount() {
    fetch("/apps/cloudfarm/cl_authorization_url/")
      .then(function (response) {
        if (response.ok) {
          return response.json();
        } else {
          cropr.notify("danger", gettext("Your account could not be linked at this time."));
          throw { status: response.status };
        }
      })
      .then((json) => {
        window.open(json.cl_authorization_url, "_blank");
        this.setState({ showWarning: true });
      })
      .catch((error) => console.error("Error:", error));
  }

  async removeAccount() {
    try {
      await APIClient.remove(
        "/api/data/claas/delete_cl_credentials",
        null,
        cropr.cloudfarm_oauth_token
      ).then((response) => {
        cropr.notify("success", gettext("Your account has been deleted successfully."));
        this.loadAccount();
      });
    } catch {
      cropr.notify("danger", gettext("Your account could not be deleted at this time."));
    }
  }

  toggle(show) {
    this.setState({ showModal: show });
  }

  render() {
    return (
      <>
        <a href="#" className="dropdown-item" onClick={() => this.toggle(true)}>
          {gettext("Connect with CLAAS Telematics")}
        </a>
        <Modal show={this.state.showModal} onHide={() => this.toggle(false)}>
          <Modal.Header closeButton>
            <Modal.Title style={{ width: "100%" }}>
              CLAAS Telematics account
              <img
                className="float-right"
                src="/static/img/CLAAS.png"
                alt="CLAAS"
                style={{ height: "30px" }}
              />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Tabs defaultActiveKey={this.state.organization ? "tractors" : "account"}>
              <Tab eventKey="account" title={gettext("Account")}>
                {this.state.showWarning ? (
                  <div className="alert alert-info">
                    {gettext("Be sure to allow this page to open popup windows in your browser.")}
                  </div>
                ) : null}
                {this.state.account ? (
                  <div>
                    <h4 className="mt-2">
                      {gettext("Currently linked account")}: {this.state.account.farm_name}
                    </h4>
                    <div className="mt-4">
                      <a className="btn btn-warning mr-1" onClick={() => this.removeAccount()}>
                        {gettext("Delete")}
                      </a>
                    </div>
                  </div>
                ) : (
                  <div>
                    <div className="mt-4">
                      <a className="btn btn-primary" onClick={() => this.authorizeAccount()}>
                        {gettext("Authorize")}
                      </a>
                    </div>
                  </div>
                )}
              </Tab>
              <Tab eventKey="tractors" title={gettext("Tractors")} disabled={!this.state.account}>
                {this.state.account ? (
                  <Tractors
                    accountName={this.state.account.farm_name}
                    headers={[gettext("Name"), gettext("Vehicle type"), gettext("License state")]}
                    tractors={this.state.account.tractors.map((t, i) => ({
                      display: [t.name, t.type ? t.type : "", t.licenseState ? t.licenseState : ""],
                      serialNr: t.id,
                      receiveOnly: false,
                    }))}
                  />
                ) : null}
              </Tab>
              <Tab eventKey="tasks" title={gettext("Tasks")} disabled={!this.state.account}>
                {this.state.account ? <Jobs online_service="C" /> : null}
              </Tab>
              <Tab eventKey="help" title={gettext("Help")}>
                <h5 className="mt-2">{gettext("What is a connection to CLAAS Telematics?")}</h5>
                {interpolate(
                  gettext(
                    "If you possess equipment that is connected to %s, you can authorize Cloudfarm to exchange data with this platform. Please talk to your dealer for more information about this system."
                  ),
                  ["CLAAS Telematics"]
                )}
                <h5 className="mt-2">{gettext("What can I do with it?")}</h5>
                {gettext(
                  "You can exchange task data directly between your vehicle and The Dacom platform/ Cloudfarm:"
                )}
                <ul>
                  <li>
                    {gettext(
                      'After connecting, your vehicle(s) will be present under the "Machines" menu. There, you can rename your vehicle, and attach a default recording template.'
                    )}
                  </li>
                  <li>
                    {gettext(
                      'You can can send the base data for your farm to each vehicle, using the buttons in the "Tractors" tab in this dialog. The base data includes field boundaries and way lines.'
                    )}
                  </li>
                  <li>
                    {gettext(
                      'You can can create scheduled tasks for your work in the "Recording" menu. If you select a connected vehicle under "Machines", the relevant field boundary and way lines will be automatically transmitted to your vehicle.'
                    )}
                  </li>
                  <li>
                    {gettext(
                      'After completing a task on the vehicle, the "as applied" data is automatically loaded in Cloudfarm, where you can review the work done.'
                    )}
                  </li>
                  <li>
                    {gettext(
                      'If you complete a task for a planning you created beforehand, this planning will automatically be marked "performed", and enriched with data from the task. Alternatively, if no planning was made, a concept recording will be created so you can conveniently convert this into a full recording.'
                    )}
                  </li>
                  <li>
                    {gettext(
                      ' If you use the vehicle to record field boundaries and way lines, you can easily import them into your Dacom farm by clicking "details" in the dataset card and go to the "geometry" tab. This way you can easily reuse this data for other vehicles, for instance by converting them into a different format with the "export machine data" functionality. '
                    )}
                  </li>
                </ul>
              </Tab>
            </Tabs>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export default LinkClaasTelematics;
